import { ConfigFn } from '@config/types'

const config = (() =>
  ({
    localStorageHideFmtOnboardingContainerKeySelectTeamList:
      'ftm_onboarding_container_select_team_list',
    localStorageHideFmtOnboardingContainerKeyTeamsTab:
      'ftm_onboarding_container_teams_tab',
    localStorageHideFmtOnboardingTooltipKey: 'ftm_onboarding_tooltip',
    moreInfoLink: '/id20932493.html',
    tooltipContentDesktopWidth: 358,
    tooltipContentMobileWidth: 332,
  }) as const) satisfies ConfigFn

export default config
